;
define("facets_item_cell_list.tpl", function(){});

